import React, { useState, useEffect } from "react";
import { CSSTransition } from "react-transition-group";
import axios from "axios";
import Swal from 'sweetalert2';

import Styles from "./form.module.css";
import EstiloBack from "../background/background.module.css";

// Import dos Input
import Nome from "../inputs-cadastro/Nome";
import Email from "../inputs-cadastro/Email";
import CPF from "../inputs-cadastro/Cpf";
import Genero from "../inputs-cadastro/Genero";
import RG from "../inputs-cadastro/Rg";
import Telefone from "../inputs-cadastro/Telefone";
import DtNasc from "../inputs-cadastro/DtNasc";
import DC from "../inputs-cadastro/DestroCanhoto";

// Import dos Input de Endereço
import Cep from "../inputs-cadastro/endereco/Cep";
import UF from "../inputs-cadastro/endereco/Uf";
import Cidade from "../inputs-cadastro/endereco/Cidade";
import Bairro from "../inputs-cadastro/endereco/Bairro";
import Rua from "../inputs-cadastro/endereco/Rua";
import Numero from "../inputs-cadastro/endereco/Numero";

import contratoPdf from "../../pdfs/EsgrimaEscola.pdf";

function faltaCampo(){
  Swal.fire({
    title: 'Alerta!',
    text: 'Preencha os campo obrigatórios.',
    icon: 'warning',
    confirmButtonText: 'OK',
    confirmButtonColor: '#fbd034'
  })
}
function alertContrato(){
  Swal.fire({
    title: 'Alerta!',
    text: 'Leia e aceite o contrato para finalizar o cadastro.',
    icon: 'warning',
    confirmButtonText: 'OK',
    confirmButtonColor: '#fbd034'
  });
}

export default function Form() {
  const [step, setStep] = useState(0);

  // States do Aluno
  const [nome, setNome] = useState("");
  const [email, setEmail] = useState("");
  const [cpf, setCpf] = useState("");
  const [genero, setGenero] = useState("");
  const [rg, setRg] = useState("");
  const [telefone, setTelefone] = useState("");
  const [nascimento, setNascimento] = useState("");
  const [mao_dominante, setMao_Dominante] = useState("");

  const [vdd, setVdd] = useState(false);

  // States do 1° Responsavel
  const [nomeResp1, setNomeResp1] = useState("");
  const [emailResp1, setEmailResp1] = useState("");
  const [cpfResp1, setCpfResp1] = useState("");
  const [generoResp1, setGeneroResp1] = useState("");
  const [rgResp1, setRgResp1] = useState("");
  const [telefoneResp1, setTelefoneResp1] = useState("");

  // States do Endereço
  const [cep, setCep] = useState("");
  const [logradouro, setLogradouro] = useState("");
  const [bairro, setBairro] = useState("");
  const [cidade, setCidade] = useState("");
  const [uf, setUf] = useState("");
  const [numero, setNumero] = useState("");

  // States de Unidades e Turmas
  const [unidades, setUnidades] = useState([]);
  const [turmas, setTurmas] = useState([]);
  const [selectedUnidade, setSelectedUnidade] = useState("");
  const [selectedTurmas, setSelectedTurmas] = useState("");
  const [selectedDay, setSelectedDay] = useState("");

  // State de contrato
  const [aceitouContrato, setAceitouContrato] = useState(false);

  const handleCheckboxChange = (event) => {
    setAceitouContrato(event.target.checked);
  };

  // Função para verificar se os campos foram preenchidos
  const areAllFieldsFilled = (fields) => {
    const emptyFields = Object.entries(fields)
      .filter(([key, value]) => value.trim() === "")
      .map(([key]) => key);

    if (emptyFields.length === 0) {
      return true;
    }

    return `Os seguintes campos estão vazios: ${emptyFields.join(", ")}`;
  };

  const nextStep = () => {
    setStep((prevStep) => {
      if (vdd) { // Maior de idade
        if (prevStep === 0) {
          setVdd(false)
          return 3 // Pular passos 2 e 3
        };
        return Math.min(prevStep + 1, steps.length - 1);
      } else { // Menor de idade
        return Math.min(prevStep + 1, steps.length - 1);
      }
    });
  };

  const prevStep = () => {
    setStep((prevStep) => {
      return Math.max(prevStep - 1, 0);
    });
  };

  const handleChange = (event) => {
    setSelectedDay(event.target.value);
  };

  const handleChangeTurmas = (turmaId) => {
    setSelectedTurmas((prev) => {
      if (prev.includes(turmaId)) {
        return prev.filter((id) => id !== turmaId); // Remove se já estiver selecionado
      } else if (prev.length < selectedDay) {
        return [...prev, turmaId]; // Adiciona se ainda houver espaço
      }
      return prev; // Mantém o mesmo estado se já atingiu o limite
    });
  };


  async function pesquisarUnidades() {
    axios.post('/api/unidade/cidade/1tipo', {
      cidade: cidade,
      tipo: 'publica'
    }).then(response => {
      setUnidades(response.data); // Define os dados no estado
    })
      .catch(error => {
        console.error("Erro ao buscar unidades:", error);
      });
  }

  useEffect(() => {
    if (selectedUnidade) {
      let id_selectedUnidade = parseInt(selectedUnidade);
      axios.get('/api/turma/formatada')
        .then(response => {
          const turmasFiltradas = response.data.filter(turma => turma.id_unidade === id_selectedUnidade);
          setTurmas(turmasFiltradas);
          setSelectedTurmas(""); // Reseta a turma ao trocar de unidade
        })
        .catch(error => {
          console.error("Erro ao buscar turmas:", error);
        });
    } else {
      setTurmas([]);
      setSelectedTurmas("");
    }
  }, [selectedUnidade]);

  const calcularIdade = (dataNascimento) => {
    const partes = dataNascimento.split('/');

    const hoje = new Date();
    const nascimento = new Date(`${partes[2]}-${partes[1]}-${partes[0]}`);
    let idadeCalculada = hoje.getFullYear() - nascimento.getFullYear();
    const mes = hoje.getMonth();
    if (mes < nascimento.getMonth() || (mes === nascimento.getMonth() && hoje.getDate() < nascimento.getDate())) {
      idadeCalculada--;
    }

    if (idadeCalculada < 18 && idadeCalculada > 0) {
      setVdd(false);
    } else {
      setVdd(true);
    }

    return idadeCalculada;
  };

  const handleBuscarCep = (cep) => {
    if (cep.length < 9) {
      setLogradouro("");
      setBairro("");
      setCidade("");
      setUf("");
      return;
    }
    fetch(`https://viacep.com.br/ws/${cep}/json/`)
      .then((response) => response.json())
      .then((dados) => {
        setLogradouro(dados.logradouro);
        setBairro(dados.bairro);
        setCidade(dados.localidade);
        setUf(dados.uf);
      })
      .catch((error) => {
        console.error('Erro ao buscar CEP:', error);
      });
  };

  async function cadastrar() {

    const unformatCPF = (cpf) => {
      return cpf.replace(/\D/g, '');
    };
    const unformatTelefone = (telefone) => {
      return telefone.replace(/\D/g, '');
    };
    const unformatRG = (rg) => {
      return rg.replace(/\D/g, '');
    };
    const converterParaSQL = (dataBR) => {
      const [dia, mes, ano] = dataBR.split('/'); // Divide a string nos "/"
      return `${ano}-${mes}-${dia}`; // Reorganiza no formato SQL
    }

    function dataAtualSQL() {
      const date = new Date();
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Meses começam em 0
      const day = String(date.getDate()).padStart(2, '0');

      return `${year}-${month}-${day}`;
    }

    let dataInicio = dataAtualSQL();

    let responseEndereco = await axios.post('/api/endereco', {
      cep: cep,
      estado: uf,
      cidade: cidade,
      bairro: bairro,
      rua: logradouro,
      numero: numero,
    });
    responseEndereco = responseEndereco.data;

    let idResp1;
    let responsePessoa;

    if (nomeResp1 !== '' && cpfResp1 !== '' && rgResp1 !== '' && emailResp1 !== '' && telefoneResp1 !== '' && generoResp1 !== '') {
      responsePessoa = await axios.post('/api/pessoa', {
        nome_pessoa: nomeResp1,
        dt_nasc_pessoa: '1999-01-01',
        cpf_pessoa: unformatCPF(cpfResp1),
        rg_pessoa: unformatRG(rgResp1),
        email_pessoa: emailResp1,
        telefone_pessoa: unformatTelefone(telefoneResp1),
        genero: generoResp1,
        id_endereco: responseEndereco.id,
      });
      responsePessoa = responsePessoa.data;
      idResp1 = responsePessoa.id;
      let responseRespAluno = await axios.post('/api/responsavel_aluno', {id_pessoa: idResp1});
    }

    responsePessoa = await axios.post('/api/pessoa', {
      nome_pessoa: nome,
      dt_nasc_pessoa: converterParaSQL(nascimento),
      cpf_pessoa: unformatCPF(cpf),
      rg_pessoa: unformatRG(rg),
      email_pessoa: email,
      telefone_pessoa: unformatTelefone(telefone),
      genero: genero,
      id_endereco: responseEndereco.id,
    })
    responsePessoa = responsePessoa.data;

    let responseAluno = await axios.post('/api/aluno', {
      id_pessoa: responsePessoa.id,
      destro_canhoto: mao_dominante,
      id_responsavel: idResp1,
      dt_inicio: dataInicio,
      tipo_aluno: 'escola',
    });


    let responseAlunoHasTurma;
    for(let i=0;i<selectedDay;i++){
      responseAlunoHasTurma = await axios.post('/api/aluno_has_turma', {
        id_aluno: responsePessoa.id,
        id_turma: parseInt(selectedTurmas[i])
      });
    }

    if (responseAlunoHasTurma) {
      alert('Cadastro concluído!');
      window.location.reload();
    }

  }

  const steps = [
    <Passo1 nextStep={nextStep} nome={nome} setNome={setNome} email={email} setEmail={setEmail}
      cpf={cpf} setCpf={setCpf} genero={genero} setGenero={setGenero} rg={rg} setRg={setRg}
      telefone={telefone} setTelefone={setTelefone} nascimento={nascimento} setNascimento={setNascimento}
      mao_dominante={mao_dominante} setMao_Dominante={setMao_Dominante} calcularIdade={calcularIdade} setStep={setStep} areAllFieldsFilled={areAllFieldsFilled} />,

    <Passo2 nextStep={nextStep} prevStep={prevStep} nomeResp1={nomeResp1} setNomeResp1={setNomeResp1} emailResp1={emailResp1} setEmailResp1={setEmailResp1}
      cpfResp1={cpfResp1} setCpfResp1={setCpfResp1} generoResp1={generoResp1} setGeneroResp1={setGeneroResp1} rgResp1={rgResp1} setRgResp1={setRgResp1}
      telefoneResp1={telefoneResp1} setTelefoneResp1={setTelefoneResp1} areAllFieldsFilled={areAllFieldsFilled} />,

    <Passo3 nextStep={nextStep} prevStep={prevStep} cep={cep} setCep={setCep} logradouro={logradouro} setLogradouro={setLogradouro}
      bairro={bairro} setBairro={setBairro} cidade={cidade} setCidade={setCidade} uf={uf} setUf={setUf} numero={numero} setNumero={setNumero} handleBuscarCep={handleBuscarCep}
      nascimento={nascimento} calcularIdade={calcularIdade} setStep={setStep} areAllFieldsFilled={areAllFieldsFilled} pesquisarUnidades={pesquisarUnidades} />,

    <Passo4 nextStep={nextStep} prevStep={prevStep} selectedUnidade={selectedUnidade} setSelectedUnidade={setSelectedUnidade} unidades={unidades} areAllFieldsFilled={areAllFieldsFilled} />,

    <Passo5 nextStep={nextStep} prevStep={prevStep} handleChange={handleChange} selectedDay={selectedDay} areAllFieldsFilled={areAllFieldsFilled}/>,
    
    <Passo6 nextStep={nextStep} prevStep={prevStep} turmas={turmas} selectedTurmas={selectedTurmas} setSelectedTurmas={setSelectedTurmas} 
    areAllFieldsFilled={areAllFieldsFilled} handleChangeTurmas={handleChangeTurmas} />,

    <Passo7 prevStep={prevStep} cadastrar={cadastrar} areAllFieldsFilled={areAllFieldsFilled} aceitouContrato={aceitouContrato} 
    handleCheckboxChange={handleCheckboxChange} />,
  ];

  return (
    <div>
      <div className={EstiloBack.backgroundContainer}>
        <img src="/backgroundDesktop/backTanger.webp" 
          alt="Background" className={EstiloBack.responsiveImg} draggable="false" 
           id={EstiloBack.backDesk}
        />
        <img src="/backgroundMobile/backTangerMob.webp" 
          alt="Background" className={EstiloBack.responsiveImg} draggable="false" 
           id={EstiloBack.backMob}
        />
      </div>
      <div className={Styles.container}>
        <form id="formcadastroaluno" autoComplete="off">
          <CSSTransition
            in={true}
            key={step}
            timeout={300}
            classNames="fade"
            unmountOnExit
          >
            {steps[step]}
          </CSSTransition>
        </form>
      </div>
    </div>
  )
}


const Passo1 = ({ nextStep, calcularIdade, setStep, nome, setNome, email, setEmail, cpf, setCpf, genero, setGenero, rg, setRg, telefone, setTelefone, nascimento, setNascimento, mao_dominante, setMao_Dominante, areAllFieldsFilled }) => (
  <>
    <div className={Styles.form}>
      <div className={Styles.centro}>
        <div className={Styles.textcenter}>
          <h1>Dados do Aluno</h1>
        </div>
        <div className={Styles.container_inputs}>
          <Nome value={nome} setValue={setNome} texto={"Aluno"} />
          <Email value={email} setValue={setEmail} />
          <CPF value={cpf} setValue={setCpf} />
          <Genero value={genero} setValue={setGenero} />
          <RG value={rg} setValue={setRg} />
          <Telefone value={telefone} setValue={setTelefone} />
          <DtNasc value={nascimento} setValue={setNascimento} />
          <DC value={mao_dominante} setValue={setMao_Dominante} />
        </div>
      </div>
    </div>
    <div className={Styles.divBotao}>
      <button type="button" onClick={() => {
        let camposPreenchidos = areAllFieldsFilled([nome, email, cpf, genero, rg, telefone, nascimento, mao_dominante])
        if (camposPreenchidos === true) {
          let idade = 0;
          idade = calcularIdade(nascimento); // Garante que a idade seja calculada
          if (idade >= 18) {
            setStep(2); // Se maior de idade, pula para o passo 3
          } else {
            nextStep(); // Continua normalmente se menor de idade
          };
        } else {
          faltaCampo();
        }
      }} className={Styles.button}>
        Próximo
        <img src={require('../../imgs/icons/seta-direita.png')} alt="icon" className={Styles.iconNavegar} draggable="false" />
      </button>
    </div>
  </>
);

const Passo2 = ({ nextStep, prevStep, nomeResp1, setNomeResp1, emailResp1, setEmailResp1, cpfResp1, setCpfResp1, generoResp1, setGeneroResp1, rgResp1, setRgResp1, telefoneResp1, setTelefoneResp1, areAllFieldsFilled }) => (
  <>
    <div className={Styles.form}>
      <div className={Styles.centro}>
        <div className={Styles.textcenter}>
          <h1>Dados do Responsável</h1>
        </div>
        <div className={Styles.container_inputs}>
          <Nome value={nomeResp1} setValue={setNomeResp1} texto={"Responsável"} />
          <Email value={emailResp1} setValue={setEmailResp1} />
          <CPF value={cpfResp1} setValue={setCpfResp1} />
          <Genero value={generoResp1} setValue={setGeneroResp1} />
          <RG value={rgResp1} setValue={setRgResp1} />
          <Telefone value={telefoneResp1} setValue={setTelefoneResp1} />
        </div>
      </div>
    </div>  
    <div className={Styles.divBotao}>
      <button type="button" onClick={prevStep} className={Styles.button}>
        <img src={require('../../imgs/icons/seta-esquerda.png')} alt="icon" className={Styles.iconNavegar} draggable="false" />
        Anterior
      </button>
      <button type="button" onClick={() => {
        if (areAllFieldsFilled([nomeResp1, emailResp1, cpfResp1, generoResp1, rgResp1, telefoneResp1]) === true) {
          nextStep()
        } else {
          faltaCampo();
        }
      }} className={Styles.button}>
        Próximo
        <img src={require('../../imgs/icons/seta-direita.png')} alt="icon" className={Styles.iconNavegar} draggable="false" />
      </button>
    </div>
  </>
);

const Passo3 = ({ nextStep, prevStep, calcularIdade, setStep, nascimento, handleBuscarCep, cep, setCep, logradouro, setLogradouro, bairro, setBairro, cidade, setCidade, uf, setUf, numero, setNumero, areAllFieldsFilled, pesquisarUnidades }) => (
  <>
    <div className={Styles.form}>
      <div className={Styles.centro}>
        <div className={Styles.textcenter}>
          <h1>Endereço</h1>
        </div>
        <div className={Styles.container_inputs}>
          <Cep onBuscarCep={handleBuscarCep} value={cep} setValue={setCep} />
          <UF value={uf} setValue={setUf} />
          <Cidade value={cidade} setValue={setCidade} />
          <Bairro value={bairro} setValue={setBairro} />
          <Rua value={logradouro} setValue={setLogradouro} />
          <Numero value={numero} setValue={setNumero} />
        </div>
      </div>
    </div>
    <div className={Styles.divBotao}>
      <button type="button" onClick={() => {
        let idade = calcularIdade(nascimento); // Garante que a idade seja calculada
        if (idade >= 18) {
          setStep(0); // Se maior de idade, pula para o passo 4
        } else {
          prevStep(); // Continua normalmente se menor de idade
        };
      }} className={Styles.button}>
        <img src={require('../../imgs/icons/seta-esquerda.png')} alt="icon" className={Styles.iconNavegar} draggable="false" />
        Anterior
      </button>
      <button type="button" onClick={() => {
        if (areAllFieldsFilled([cep, uf, cidade, bairro, logradouro, numero]) === true) {
          nextStep()
        } else {
          faltaCampo();
        }
        pesquisarUnidades();
      }} className={Styles.button}>
        Próximo
        <img src={require('../../imgs/icons/seta-direita.png')} alt="icon" className={Styles.iconNavegar} draggable="false" />
      </button>
    </div>
  </>
);

const Passo4 = ({ nextStep, prevStep, selectedUnidade, setSelectedUnidade, unidades, areAllFieldsFilled }) => (
  <>
    <div className={Styles.form}>
      <div className={Styles.centro}>
        <div className={Styles.textcenter}>
          <h1>Escolha a Sua Unidade</h1>
        </div>
        <div className={Styles.container_Passo_Escolhas}>
          <div className={Styles.divSelect}>
            <select
              id="escolha_unidade"
              name="escolha_unidade"
              className={Styles.select}
              value={selectedUnidade}
              onChange={(e) => setSelectedUnidade(e.target.value)}
            >
              <option value="" disabled>Selecionar Unidade</option>
              {unidades.map(unidade => (
                <option key={unidade.id_unidade} value={unidade.id_unidade}>
                  {unidade.nome_unidade}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
    </div>
    <div className={Styles.divBotao}>
      <button type="button" onClick={prevStep} className={Styles.button}>
        <img src={require('../../imgs/icons/seta-esquerda.png')} alt="icon" className={Styles.iconNavegar} draggable="false" />
        Anterior
      </button>
      <button type="button" onClick={() => {
        if (areAllFieldsFilled([selectedUnidade]) === true) {
          nextStep()
        } else {
          faltaCampo();
        }
      }} className={Styles.button}>
        Próximo
        <img src={require('../../imgs/icons/seta-direita.png')} alt="icon" className={Styles.iconNavegar} draggable="false" />
      </button>
    </div>
  </>
);

const Passo5 = ({ nextStep, prevStep, handleChange, selectedDay, areAllFieldsFilled}) => (
  <>
    <div className={Styles.form}>
      <div className={Styles.centro}>
        <div className={Styles.textcenter}>
          <h1>Quantos dias por semana<br />Você vai Treinar?</h1>
        </div>
        <div className={Styles.divEscolhaDia}>
          {[1, 2, 3, 4, 5, 6].map((num) => (
            <div key={num}>
              <input 
                type="radio" 
                id={num.toString()} 
                name="dia" 
                value={num} 
                checked={selectedDay === num.toString()} 
                onChange={handleChange} 
              />
              <label htmlFor={num.toString()}>{num} Dia{num > 1 ? "s" : ""}</label>
            </div>
          ))}
        </div>
      </div>
    </div>
    <div className={Styles.divBotao}>
      <button type="button" onClick={prevStep} className={Styles.button}>
        <img src={require('../../imgs/icons/seta-esquerda.png')} alt="icon" className={Styles.iconNavegar} draggable="false" />
        Anterior
      </button>
      <button type="button" onClick={() => {
          if(areAllFieldsFilled([selectedDay]) === true){
            nextStep();
          }else{
            faltaCampo();
          }
        
        }} className={Styles.button}>
        Próximo
        <img src={require('../../imgs/icons/seta-direita.png')} alt="icon" className={Styles.iconNavegar} draggable="false" />
      </button>
    </div>
  </>
);

const Passo6 = ({ nextStep, prevStep, turmas, selectedTurmas, setSelectedTurmas, areAllFieldsFilled, handleChangeTurmas }) => (
  <>
    <div className={Styles.form}>
      <div className={Styles.centro}>
        <div className={Styles.textcenter}>
          <h1>Escolha a Sua Turma</h1>
        </div>
        <div className={Styles.divEscolhaTurma}>
          {turmas.length > 0 ? (
            turmas.map((turma) => (
              <div key={turma.id_turma} className={Styles.escolhaTurma}>
                <input
                  type="checkbox"
                  id={`turma-${turma.id_turma}`}
                  name="escolha_turma"
                  value={turma.id_turma}
                  checked={selectedTurmas.includes(turma.id_turma)}
                  onChange={() => handleChangeTurmas(turma.id_turma)}
                />
                <label htmlFor={`turma-${turma.id_turma}`}>{turma.nome_formatado}</label>
              </div>
            ))
          ) : (
            <p>Nenhuma turma disponível.</p>
          )}
        </div>
      </div>
    </div>
    <div className={Styles.divBotao}>
      <button type="button" onClick={prevStep} className={Styles.button}>
        <img src={require('../../imgs/icons/seta-esquerda.png')} alt="icon" className={Styles.iconNavegar} draggable="false" />
        Anterior
      </button>
      <button type="button" onClick={() => {
          if(selectedTurmas !== ''){
            nextStep();
          }else{
            faltaCampo();
          }
        }} className={Styles.button}>
        Próximo
        <img src={require('../../imgs/icons/seta-direita.png')} alt="icon" className={Styles.iconNavegar} draggable="false" />
      </button>
    </div>
  </>
);

const Passo7 = ({ prevStep, cadastrar, areAllFieldsFilled, aceitouContrato, handleCheckboxChange }) => (
  <>
    <div className={Styles.form}>
      <div className={Styles.centro}>
        <div className={Styles.textcenter}>
          <h1>Contrato</h1>
        </div>
        <div className={Styles.divContrato}>
          <div className={Styles.contrato}>
            <a href={contratoPdf} target="_blank" 
              rel="noopener noreferrer" 
              className={Styles.linkContrato}
              >
              📄Visualizar Contrato(PDF)
            </a>
            <div className={Styles.contratoContainer}>
              <input type="checkbox" id="aceitarContrato" checked={aceitouContrato} onChange={handleCheckboxChange} />
              <label htmlFor="aceitarContrato">Estou ciente e concordo.</label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className={Styles.divBotao}>
      <button type="button" onClick={prevStep} className={Styles.button}>
        <img src={require('../../imgs/icons/seta-esquerda.png')} alt="icon" className={Styles.iconNavegar} draggable="false" />
        Anterior
      </button>
      <button type="button" className={Styles.button} onClick={() => {
        if (aceitouContrato === true) {
          cadastrar();
        } else {
          alertContrato();
        }
      }}>
        Finalizar Cadastro
        <img src={require('../../imgs/icons/verifica.png')} alt="icon" className={Styles.iconNavegar} draggable="false" />
      </button>
    </div>
  </>
);